import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box, Typography, TextField, InputLabel, FormControlLabel, IconButton, InputBase, useTheme } from "@mui/material"
import style from "./style";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Select, MenuItem } from "@mui/material";
import countryList from "react-select-country-list";
import Modal from "../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LoadingButton } from "@mui/lab";
import Checkbox from "@mui/material/Checkbox";
import dayjs from "dayjs";
import { Search } from "@mui/icons-material";


const SuperAdmin = ({ allowances, fringes, pensions, handlePension, handleFringe, taxes, handleTax, leaves, handleLeave, data, handleTaxTable, getTaxTable, handleAllowance }) => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [fixed, setFixed] = useState();
  const [rate, setRate] = useState();
  const [countryTax, setCountryTax] = useState();

  useEffect(() => {
    if (allowances && allowances.length > 0) {
      setAllowance(allowances[0].name);
      setAllowanceTax(allowances[0].isTaxable);
    }

    if (fringes && fringes.length > 0) {
      setFringe(fringes[0].name);
      setFringeTax(fringes[0].isTaxable);
    }

    if (pensions && pensions.length > 0) {
      setPension(pensions[0].name);
      setPensionTax(pensions[0].isTaxable);
    }
    if (taxes && taxes.length > 0) {
      setFrom(taxes[0].start ? dayjs(taxes[0].start) : dayjs());
      setTo(taxes[0].end ? dayjs(taxes[0].end) : dayjs());
    }
    if (leaves && leaves.length > 0) {
      setLeave(leaves[0]?.leave?.type);
      setLeaveBalance(leaves[0]?.leave?.leaveBalance);
      setLeaveTax(leaves[0]?.leave?.isPaid);
    }

  }, [allowances, fringes, pensions, taxes, leaves]);

  const [allowance, setAllowance] = useState();
  const [allowanceTax, setAllowanceTax] = useState(false);
  const [fringeTax, setFringeTax] = useState(false);
  const [pension, setPension] = useState();
  const [pensionTax, setPensionTax] = useState(false);
  const [fringe, setFringe] = useState();
  const [from, setFrom] = useState(dayjs());
  const [to, setTo] = useState(dayjs());
  const [leave, setLeave] = useState();
  const [leaveBalance, setLeaveBalance] = useState();
  // const [country, setCountry] = useState(data?.country);
  const [leaveTax, setLeaveTax] = useState(false);
  const options = countryList().getData();
  const [country, setCountry] = useState(data?.country);
  // const [cards, setCards] = useState([{ id: 1 }]); // Array to track cards





  return (
    <>

      <Box sx={style.reportGrid}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Super Admin</Typography>
        </Box>


      </Box>
      <>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Allowances</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={4} sx={style.gridbox}>
            <Grid container sx={style.gridContiner}>
              <Grid item xs={12} lg={12}>
                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>Allowances Type</InputLabel>
                  <Box sx={style.selectGrid}>
                    <TextField value={allowance}
                      onChange={(e) => setAllowance(e.target.value)}
                    >

                    </TextField>
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={12} lg={12}>

                <Box sx={style.inputSection}>
                  <FormControlLabel
                    sx={style.formControlLabel}
                    control={<Checkbox checked={allowanceTax} />}
                    onChange={(e) => setAllowanceTax(e.target.checked)}
                    label="Is Taxable"
                  />
                </Box>
              </Grid>
              <Box sx={{ ...style.btnSection, width: "100%" }}>
                <Box sx={{ ...style.btnPdf, textAlign: "right" }}>
                  <LoadingButton
                    variant="contained"
                    disabled={!allowance}
                    onClick={() => handleAllowance(allowance, allowanceTax, allowances?.[0]?._id)}
                    type="submit"
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </>
      <>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Fringe</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={4} sx={style.gridbox}>
            <Grid container sx={style.gridContiner}>
              <Grid item xs={12} lg={12}>
                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>Fringe Type</InputLabel>
                  <Box sx={style.selectGrid}>
                    <TextField value={fringe}
                      onChange={(e) => setFringe(e.target.value)}></TextField>
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={12} lg={12}>

                <Box sx={style.inputSection}>
                  <FormControlLabel
                    sx={style.formControlLabel}
                    control={<Checkbox checked={fringeTax} />}
                    onChange={(e) => setFringeTax(e.target.checked)}
                    label="Is Taxable"
                  />

                </Box>
              </Grid>
              <Box sx={{ ...style.btnSection, width: "100%" }}>
                <Box sx={{ ...style.btnPdf, textAlign: "right" }}>
                  <LoadingButton
                    variant="contained"
                    disabled={!fringe}
                    onClick={() => handleFringe(fringe, fringeTax, fringes?.[0]?._id)}
                    type="submit"
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>


                </Box>

              </Box>
            </Grid>
          </Grid>

        </Grid>
      </>

      <>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Pension</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={4} sx={style.gridbox}>
            <Grid container sx={style.gridContiner}>
              <Grid item xs={12} lg={12}>
                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>Pension Type</InputLabel>
                  <Box sx={style.selectGrid}>
                    <TextField value={pension}
                      onChange={(e) => setPension(e.target.value)}></TextField>
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={12} lg={12}>

                <Box sx={style.inputSection}>
                  <FormControlLabel
                    sx={style.formControlLabel}
                    control={<Checkbox checked={pensionTax} />}
                    onChange={(e) => setPensionTax(e.target.checked)}
                    label="Is Taxable"
                  />

                </Box>
              </Grid>
              <Box sx={{ ...style.btnSection, width: "100%" }}>
                <Box sx={{ ...style.btnPdf, textAlign: "right" }}>
                  <LoadingButton
                    variant="contained"
                    disabled={!pension}
                    onClick={() => handlePension(pension, pensionTax, pensions?.[0]?._id)}
                    type="submit"
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>


                </Box>

              </Box>
            </Grid>
          </Grid>

        </Grid>
      </>


      <>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Tax</Typography>

        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={12} sx={style.gridbox}>
            <Grid container>
              <Grid item xs={12} lg={4}>

                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>From</InputLabel>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box>
                      <DatePicker
                        value={from}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setFrom(newValue); }}
                      />
                    </Box>
                  </LocalizationProvider>
                </Box>

              </Grid>
              <Grid item xs={12} lg={4}>

                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>To</InputLabel>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box>
                      <DatePicker
                        value={to}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setTo(newValue); }}
                      />
                    </Box>
                  </LocalizationProvider>

                </Box>

              </Grid>

            </Grid>
          </Grid>
          <Box sx={style.btnSection}>

            <Box sx={style.btnGrid}>
              <LoadingButton
                variant="contained"
                onClick={() => handleTax(from, to, taxes?.[0]?._id)}
                type="submit"
                color="primary"
                disabled={!from || !to}

                sx={style.submitButton}
              >
                Save
              </LoadingButton>


            </Box>
          </Box>
        </Grid>
      </>

      <>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Leave</Typography>

        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={4} sx={style.gridbox}>
            <Grid container sx={style.gridContiner}>
              <Grid item xs={12} lg={12}>
                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>Leave Type</InputLabel>
                  <Box sx={style.selectGrid}>
                    <TextField value={leave}
                      onChange={(e) => setLeave(e.target.value)}></TextField>
                  </Box>


                </Box>
              </Grid>

              <Grid item xs={12} lg={12}>
                <Box sx={style.inputSection}>
                  <InputLabel sx={style.labels}>Leave Balance</InputLabel>
                  <Box sx={style.selectGrid}>
                    <TextField value={leaveBalance}
                      type="number"
                      onChange={(e) => setLeaveBalance(e.target.value)}></TextField>
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={12} lg={12}>

                <Box sx={style.inputSection}>
                  <FormControlLabel
                    sx={style.formControlLabel}
                    control={<Checkbox defaultChecked={leaveTax} />}
                    checked={leaveTax}
                    onChange={(e) => setLeaveTax(e.target.checked)}
                    label="Is Taxable"
                  />

                </Box>
              </Grid>
              <Box sx={{ ...style.btnSection, width: "100%" }}>
                <Box sx={{ ...style.btnPdf, textAlign: "right" }}>
                  <LoadingButton
                    variant="contained"
                    onClick={() => handleLeave(leave, leaveTax, leaveBalance, leaves?.[0]?._id)}
                    type="submit"
                    disabled={!leave || !leaveBalance}
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>


                </Box>
              </Box>
            </Grid>
          </Grid>

        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Tax Table</Typography>
        </Box>

        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={12} sx={style.gridbox}>
            <Box sx={{ ...style.inputBoxEnd, flex: "auto" }}>
              <LoadingButton
                variant="contained"
                onClick={() => setOpen(true)}
                type="submit"
                color="primary"
                sx={style.submitButton}
              >
                Add+
              </LoadingButton>

            </Box>

            <Box sx={style.modalGrid}>
              <Box sx={style.inputBoxs}>
                <Typography >Search</Typography>
                <Box
                  display="flex"
                  backgroundColor={theme.palette.lightGray.main}
                  borderRadius="35px"
                  width="100%"
                  marginRight={{ xs: 0, md: "10px" }}
                  marginBottom={{ xs: "20px", md: 0 }}
                >

                  <IconButton type="button" sx={{ p: 1 }}>
                    <Search />
                  </IconButton>
                  <InputBase sx={{ flex: 1, fontSize: "12px" }} placeholder="Search" onChange={(e) => onchange(e.target.value)} />
                </Box>
              </Box>
              <Box sx={style.inputBoxs}>
                <Typography sx={style.inputTexts}>Select Year</Typography>
                <Select
                  value={country || data?.country}
                  onChange={(event) => { setCountry(event.target.value), getTaxTable(event.target.value) }}
                  name="country"
                  sx={style.hoursInput}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>

                  {options.map((country, index) => (
                    <MenuItem
                      key={index}
                      sx={style.dropDownMenu}
                      value={country.label}
                    >
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={style.inputBoxs}>
                <Typography sx={style.inputTexts}>Country</Typography>
                <Select
                  value={country || data?.country}
                  onChange={(event) => { setCountry(event.target.value), getTaxTable(event.target.value) }}
                  name="country"
                  sx={style.hoursInput}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>

                  {options.map((country, index) => (
                    <MenuItem
                      key={index}
                      sx={style.dropDownMenu}
                      value={country.label}
                    >
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

            </Box>


            <TableContainer sx={style.noShadow}>
              <Table  >
                <TableHead>
                  <TableRow>
                    <TableCell sx={style.tableHead}>Taxable Income (R)</TableCell>
                    <TableCell sx={style.tableHead}>Rates of tax (R)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.taxSlabs?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography variant="h6">No Data</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    data?.taxSlabs?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell sx={style.tableData}>{item?.minIncome} - {item?.maxIncome}</TableCell>
                        <TableCell sx={style.tableData}>{item?.fixedAmount} + {item?.ratePercentage}% of taxable income above {item?.minIncome} </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>

              </Table>

            </TableContainer>
          </Grid>
        </Grid>

        <Modal open={open} setOpen={setOpen} disabled={""} btnText={"Add Tax"} title={"Tax"} handleCheck={() => { handleTaxTable(min, max, fixed, rate, countryTax) }}>
          <Box sx={style.modalGrid}>
            <Box sx={{ mr: 2 }}>
              <InputLabel sx={style.label}>Minimun Income</InputLabel>
              <TextField name="desc" value={min}
                onChange={(e) => { setMin(e.target.value) }}
              />


            </Box>
            <Box>
              <InputLabel sx={style.label}>Maximum Income</InputLabel>
              <TextField name="desc" value={max}
                onChange={(e) => { setMax(e.target.value) }}
              />

            </Box>
          </Box>

          <Box sx={style.modalGrid}>
            <Box sx={{ mr: 2 }}>
              <InputLabel sx={style.label}>Fixed Amount</InputLabel>
              <TextField name="desc" value={fixed}
                onChange={(e) => { setFixed(e.target.value) }}
              />
            </Box>
            <Box>
              <InputLabel sx={style.label}>Rate Percent</InputLabel>
              <TextField name="desc" value={rate}
                onChange={(e) => { setRate(e.target.value) }}
              />
            </Box>
          </Box>
          <Box sx={style.modalGrid}>
            <Box sx={{ width: "100%" }}>
              <InputLabel sx={style.label}>Country</InputLabel>
              <Select
                value={countryTax}
                onChange={(event) => { setCountryTax(event.target.value) }}
                name="country"
                sx={style.hoursInput}
                displayEmpty
              >
                <MenuItem disabled value="">
                  Select
                </MenuItem>

                {options.map((country, index) => (
                  <MenuItem
                    key={index}
                    sx={style.dropDownMenu}
                    value={country.label}
                  >
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
        </Modal>
      </>
    </>

  )
}
export default SuperAdmin;
